import React, { useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { getCall } from "../../../Api/axios";
import {
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";


const DynamicSubcategorySelect = ({ item, value, onChange, error }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const getProductNames = async (keyword) => {
    try {
      const url = `/api/v1/seller/product/search?keyword=${encodeURIComponent(keyword)}&page=0&limit=20`;
      const result = await getCall(url);
      // Handle new SearchResult structure
      const searchResult = result.data || {};
      return searchResult.results || [];
    } catch (error) {
      console.log(error);
    }
  }
  const fetchOptions = async (keyword) => {
    setLoading(true);
    try {
      const response = getProductNames(keyword);
      const data = await response;
      if (Array.isArray(data)) {
        // Sort results by score in descending order (highest score first)
        const sortedData = data.sort((a, b) => (b.score || 0) - (a.score || 0));
        setOptions(sortedData);
      } else {
        console.warn("Unexpected data format:", data);
        setOptions([]);  // Fallback
      }
    } catch (err) {
      console.error("Failed to fetch options", err);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = React.useMemo(() => debounce(fetchOptions, 300), []);
  useEffect(() => () => debouncedFetch.cancel(), [debouncedFetch]);

  return (
    <Autocomplete
      disableClearable={item.disableClearable}
      options={options}
      loading={loading}
      value={value || null}
      getOptionLabel={(option) => option.name || ""}
      isOptionEqualToValue={(option, val) => option.pid === val.pid}
      onInputChange={(_, inputValue) => {
        if (inputValue) debouncedFetch(inputValue);
      }}
      onChange={(_, newValue) => {
        // store full object or just newValue.id based on use case
        onChange(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={item.title}
          variant={item.variant ? item.variant : "standard"}
          placeholder={item.placeholder}
          error={!!error}
          helperText={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default DynamicSubcategorySelect;